import { render, staticRenderFns } from "./deleteSupplierCoupon.vue?vue&type=template&id=af566272"
import script from "./deleteSupplierCoupon.vue?vue&type=script&lang=js"
export * from "./deleteSupplierCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports